import React from 'react'
import propTypes from 'prop-types'
import { addEvent, subscribe, getOffSet } from 'us-common-utils'
import WbUtils from '../../utils/whiteboard'
import Icon from '../Icon'
import './index.less'

class Whiteboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      type: 'pen',
    }
    this.whiteboard = null
    this.subscribe = props.subscribe || subscribe
  }

  componentDidMount() {
    this.whiteboard = new WbUtils({
      allowMousefollow: this.props.allowMousefollow,
      allowDraw: this.props.allowDraw,
      id: 'whiteboard',
      color: this.props.color && '#ff0000',
      width: this.props.style.width,
      height: this.props.style.height,
      disabled: this.props.disabled,
      onDrawDown: this.props.onDrawDown,
      onDrawUp: this.props.onDrawUp,
      postUpload: () => ({}),
    })

    if (this.props.allowPubSub && this.subscribe) {
      this.addListenerEvent()
    }

    this.dragEvent()
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.style.width !== nextProps.style.width ||
      this.props.style.height !== nextProps.style.height
    ) {
      this.canvasSize({
        width: this.props.style.width,
        height: this.props.style.height,
      })
    }
  }

  dragEvent = () => {
    this.dragTarget = document.querySelector('.whiteboard-component-tool')
    if (this.dragTarget) {
      addEvent(this.dragTarget, 'mousedown', this.dragDown, false)
      addEvent(this.dragTarget, 'touchstart', this.dragDown, false)

      addEvent(document, 'mousemove', this.dragMove, false)
      addEvent(document, 'mouseup', this.dragUp, false)
      addEvent(document, 'mouseleave', this.dragUp, false)

      addEvent(document, 'touchmove', this.dragMove, false)
      addEvent(document, 'touchend', this.dragUp, false)
    }
  }

  getTouchPointPosition = (e) => {
    const touch = e.touches && e.targetTouches && e.targetTouches[0]
    const clientX = touch ? touch.clientX : e.clientX
    const clientY = touch ? touch.clientY : e.clientY
    return {
      clientX,
      clientY,
    }
  }

  dragDown = () => {
    this.getEleOffSet = getOffSet(this.dragTarget)
    this.drag = true
  }

  dragMove = (e) => {
    if (this.drag) {
      const canvas = document.getElementById('whiteboardBox')
      const getCanvasOffSet = getOffSet(canvas)
      const getTouchPointPosition = this.getTouchPointPosition(e)
      const disX = getTouchPointPosition.clientX - this.getEleOffSet.left;
      const disY = getTouchPointPosition.clientY - this.getEleOffSet.top;

      const left = this.getEleOffSet.left + disX - getCanvasOffSet.left - this.dragTarget.clientWidth / 2
      const top = this.getEleOffSet.top + disY - getCanvasOffSet.top - this.dragTarget.clientHeight / 2
      if (
        left >= 0 && left < canvas.clientWidth - 70 &&
        top >= 0 && top < canvas.clientHeight - 60
      ) {
        this.dragTarget.style.right = 'initial';
        this.dragTarget.style.left = `${left}px`;
        this.dragTarget.style.top = `${top}px`;
      }
    }
  }

  dragUp = () => {
    this.drag = false
  }

  addListenerEvent = () => {
    this.subscribe('canvas-draw', this.listenerRedraw);
    this.subscribe('canvas-clear', () => { this.whiteboard.clear() })
    this.subscribe('canvas-undo', () => { this.whiteboard.undo() })
    this.subscribe('canvas-type', (msg, type) => {
      this.setState({ type })
      this.whiteboard.typeChoose(type)
      if (type === 'pen') {
        this.canvasWidthChoose(10)
      } else {
        this.canvasWidthChoose(50)
      } 
    }) 
  }

  canvasSize = (style) => {
    this.whiteboard.updateScreenSize(style)
  }

  listenerRedraw = (msg, data) => {
    if (data) {
      this.whiteboard.reDraw(data)
    }
  }

  canvasUndo = () => {
    this.whiteboard.undo()
    this.props.onCanvasUndoChange()
  }

  canvasClear = () => {
    this.whiteboard.clear()
    this.props.onCanvasClearChange()
  }

  canvasTypeChoose = (type) => {
    this.setState({ type })
    this.whiteboard.typeChoose(type)
    if (type === 'pen') {
      this.canvasWidthChoose(10)
    } else {
      this.canvasWidthChoose(50)
    }
    this.props.onCanvasTypeChooseChange(type)
  }

  canvasWidthChoose = (width) => {
    this.whiteboard.widthChoose(width)
  }

  canvasColorChoose = (color) => {
    this.setState({ canvasColor: color, type: 'pen' })
    this.whiteboard.typeChoose('pen')
    this.whiteboard.colorChoose(color)
  }

  render() {
    const props = this.props
    return (<div
      className="whiteboard-component-container"
      id="whiteboardBox"
      style={Object.assign({}, props.style, {
        display: props.visible ? 'block' : 'none'
      })}
    >
      {/*
        <div id="select">
          <Button size='small' id="pen" onClick={() => (props.onChange('type', 'pen'))}>铅笔</Button>
          <Button size='small' id="line" onClick={() => (props.onChange('type', 'line'))}>直线</Button>
          <Button size='small' id="rect" onClick={() => (props.onChange('type', 'rect'))}>矩形</Button>
          <Button size='small' id="arc" onClick={() => (props.onChange('type', 'circle'))}>圆形</Button>
          <Button size='small' id="poly" onClick={() => (props.onChange('type', 'poly'))}>多边形</Button>
          <Button size='small' id="eraser" onClick={() => (props.onChange('type', 'eraser'))}>橡皮檫</Button>
          <Button size='small' id="stroke" onClick={() => (props.onChange('style', 'stroke'))}>描边</Button>
          <Button size='small' id="fill" onClick={() => (props.onChange('style', 'fill'))}>填充</Button>
          <Button size='small' id="back" onClick={() => (props.onChange('undo'))}>撤销</Button>
          <Button size='small' id="clear" onClick={() => (props.onChange('clear'))}>清除</Button>
          <input type="color" id="color" onChange={(e) => (props.onChange('color', e.target.value))} />
          <input type="number" id="lineWidth" onChange={(e) => (props.onChange('width', e.target.value))} />
          <input type="number" id="n" onChange={(e) => (props.onChange('n', e.target.value))} />
        </div>
      */}
      <canvas
        className="whiteborad-follow"
        id="whiteboardFollow"
        width={props.style.width}
        height={props.style.height}
      />
      <canvas
        className="whiteborad"
        id="whiteboard"
        width={props.style.width}
        height={props.style.height}
      />
       {
        !props.hideTool && <div className="whiteboard-component-tool">
          <a className="tool-clear" onClick={this.canvasClear}>
            <Icon type="quanbuqingchu" />
          </a>
          <a className="tool-undo" onClick={this.canvasUndo}>
            <Icon type="chexiaoshangyibu" />
          </a>
          <div className="tool-pen-box">
            <a className="tool-pen" onClick={() => {
              this.canvasTypeChoose('pen')
              this.setState({ showBrush: !this.state.showBrush })
            }}>
              <Icon type="maobi" className={this.state.type === 'pen' ? 'tool-focus' : ''} />
            </a>
            {
              this.props.allowChossBrush && this.state.showBrush && <div className="pen-brush">
                <a
                  className="pen-brush-color"
                  style={{
                    borderColor: !this.state.canvasColor ? '#F79A43' : '#ffffff' }}
                  onClick={() => (this.canvasColorChoose(false))}
                />
                <a
                  className="pen-brush-color"
                  style={{
                    background: '#fd434d',
                    borderColor: this.state.canvasColor === '#fd434d' ? '#F79A43' : '#ffffff' }}
                  onClick={() => (this.canvasColorChoose('#fd434d'))}
                />
              </div>
            }
          </div>
          <a className="tool-rubber" onClick={() => (this.canvasTypeChoose('eraser'))}>
            <Icon type="xiangpi1" className={this.state.type === 'eraser' ? 'tool-focus' : ''} />
          </a>
        </div>
      }
    </div>)
  }
}

Whiteboard.propType = {
  /**
   * 白板的基础样式，主要有宽度和高度
   */
  style: propTypes.object,
  /**
   * 是否显示白板
   */
  visible: propTypes.bool,
  /**
   * 是否显示工具条
   */
  hideTool: propTypes.bool,
  /**
   * 是否允许选择笔刷
   */
  allowChossBrush: propTypes.bool,
  /**
   * 是否禁止画板初始化
   */
  disabled: propTypes.bool,
  /**
   * 是否允许通过PubSub来，触发
   * whiteboard-redraw: 手动绘制
   * canvas-clear: 手动清屏
   * canvas-undo: 手动撤销
   * canvas-type: 手动切换画笔类型
   */
  allowPubSub: propTypes.bool,
  /**
   * 是否显示鼠标跟随特效
   */
  allowMousefollow: propTypes.bool,
  /**
   * 是否允许画画
   */
  allowDraw: propTypes.bool,
  /**
   * 设置画笔的颜色
   */
  color: propTypes.string,
  /**
   * 开始画画时候的回调函数
   */
  onDrawDown: propTypes.func,
  /**
   * 结束画画时的回调函数
   */
  onDrawUp: propTypes.func,

  /**
   * 触发撤销按钮的回调函数
   */
  onCanvasUndoChange: propTypes.func,
  /**
   * 触发清屏按钮的回调函数
   */
  onCanvasClearChange: propTypes.func,
  /**
   * 触发选择画笔类型的回调函数
   */
  onCanvasTypeChooseChange: propTypes.func,
}

Whiteboard.defaultProps = {
  style: {},
  visible: true,
  hideTool: false,
  allowChossBrush: false,

  disabled: false,
  allowPubSub: false,
  allowMousefollow: false,
  allowDraw: false,
  color: '',
  onDrawDown: (e) => {console.log(e)},
  onDrawUp: (e) => {console.log(e)},

  onCanvasUndoChange: (e) => {console.log(e)},
  onCanvasClearChange: (e) => {console.log(e)},
  onCanvasTypeChooseChange: (e) => {console.log(e)},
}

export default Whiteboard


// WEBPACK FOOTER //
// ./src/components/Whiteboard/index.js